import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'ResourceRecord'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const MaterialResourcerecordApi = ZJApi.defineNewApi('MaterialResourcerecordApi', factory);

export default MaterialResourcerecordApi;